import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, ActivationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { BreadcrumbRouterComponent, RowComponent } from '@coreui/angular-pro';
// BreadcrumbRouterService vive en @coreui/angular-pro

@Component({
    selector: 'app-default-breadcrumb',
    imports: [
        BreadcrumbRouterComponent,
        RowComponent
    ],
    templateUrl: './default-breadcrumb.component.html'
})
export class DefaultBreadcrumbComponent {

  public title!: string;
  readonly #router = inject(Router);

  constructor(
    // private breadcumbService: BreadcrumbRouterService
  ) {
    this.#router.events.pipe(
      filter(event => event instanceof ActivationEnd && !event.snapshot.firstChild),
      map(value => {
        const activatedRoute = <ActivatedRoute><unknown>value;
        return activatedRoute.snapshot?.data?.['title'] ?? null;
      }),
      takeUntilDestroyed()
    ).subscribe((title: string | null) => {
      this.title = title ?? 'Title';
    });
  }

}
